export enum ContractApplicabilityFilter {
  APPLICABLE = 'applicable',
  INAPPLICABLE = 'inapplicable',
}

export enum BoxesRevenueFilterKeys {
  selectedWarehouses = 'selectedWarehouses',
  isApplicable = 'isApplicable',
  startDate = 'startDate',
  endDate = 'endDate',
  squareFrom = 'squareFrom',
  squareTo = 'squareTo',
  unitName = 'unitName',
}
